import React, { useContext } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import BackendForm from "./Component/backend/BackendForm";
import AddClient from "./Component/backend/AddClient";
import ViewClient from "./Component/backend/ViewClient";
import Header from "./Component/backend/Header";
import RightSidebar from "./Component/backend/RightSidebar";
import Leftbar from "./Component/backend/Leftbar";
import Login from "./Component/Login";
import ProtectedRoute from "./Component/ProtectedRoute";
import { AuthContext } from "./AuthContext";
import { useSelector } from "react-redux";
import Unauthorized from "./Component/Unauthorized";
import ViewProfile from "./Component/backend/ViewProfile";
// import AudioToText from './Component/backend/AudioToText';
import AudioToText from "./Component/backend/AudioToText";
import ClientValidation from "./Component/backend/ClientValidation";

// Import ToastContainer from react-toastify
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css"; // Don't forget the CSS file
import ViewPyLogs from "./Component/backend/ViewPyLogs";
import ViewPyLogDetails from "./Component/backend/ViewPyLogDetails";
import ButtonContainer from "./Component/backend/buttonApp/ButtonContainer";
import ButtonSettingsForm from "./Component/backend/buttonApp/ButtonSettingsForm";
import SplashContent from "./Component/backend/buttonApp/SplashContent";
import GlobalSettingForm from "./Component/backend/buttonApp/GlobalSettingForm";
import ButtonLogs from "./Component/backend/buttonApp/ButtonLogs";
import QrLink from "./Component/backend/buttonApp/buttonAppFrontendView/QrLink";
import AvailablitySettings from "./Component/backend/buttonApp/AvailablitySettings";
import QuestionBank from "./Component/backend/TriviaQuiz/QuestionBank";
import TriviaQuizMenu from "./Component/backend/TriviaQuiz/TriviaQuizMenu";
import QuizReporting from "./Component/backend/buttonApp/QuizReporting";
import GlobalSettings from "./Component/GlobalSettings";
import WayfinderManagement from "./Component/backend/WayfinderManagement";
import MappedInDataExplorer from "./Component/Wayfinder/MappedInDataExplorer";
import AssetsReport from "./Component/AssetsReport";
import FilterReport from "./Component/backend/LLM/FilterReport";
import dummyTest from "./dummyTest";
import UploadTest from "./uploadTest";

import { EnableTwoFa } from "./Component/2FA/EnableTwoFa";
import { TwoFaVerification } from "./Component/2FA/TwoFaVerification";
import ForgotPasswordInput from "./Component/forgot_password/ForgotPasswordInput";
import ResetPasswordPage from "./Component/forgot_password/ResetPasswordPage";
import BillingTrackTables from "./Component/backend/BillingTrackTables";
import ClientLogin from "./Component/ClientLogin";
import NotFound from "./Component/NotFound";
import { WayfinderMain } from "./Component/Wayfinder/WayfinderMain";
import AvatarScreenTest from "./Component/Wayfinder/AvatarScreenTest";
import { MainLocationTab } from "./Component/Wayfinder/MainTabs/MainLocationTab";
import WayfinderLocation from "./Component/Wayfinder/WayfinderLocation";
import VideoManagementAdmin from "./Component/backend/VideoManagementAdmin";
import MobileQRScanPage from "./Component/Wayfinder/MobileQRScanPage";
import DirectMapRedirectPage from "./Component/Wayfinder/DirectMapRedirectPage";
import HeyGenTestComponent from "./Component/HeyGenTestComponent";
import QRCodeScanLogs from "./Component/Wayfinder/QRCodeScanLogs";

import WayfinderMainCategory from "./Component/Wayfinder/WayfinderMainCategory";
import WayfinderMainSubCategory from "./Component/Wayfinder/WayfinderMainSubCategory";
import WayfinderSubCategory from "./Component/Wayfinder/WayfinderSubCategory";
import WayfinderCategory from "./Component/Wayfinder/WayfinderCategory";
import CategoryOrderSelector from "./Component/Wayfinder/CategoryOrderSelector";
import SubCategoryOrderSelector from "./Component/Wayfinder/SubCategoryOrderSelector";
import LocationSelector from "./Component/Wayfinder/LocationSelector";
import CombinedCategorySubcategoryOrderPage from "./Component/Wayfinder/CombinedCategorySubcategoryOrderPage";
import { MainNavigationTab } from "./Component/Wayfinder/MainTabs/MainNavigationTab";
import { MainBrandingTab } from "./Component/Wayfinder/MainTabs/MainBrandingTab";
import WayfinderSubLocation from "./Component/Wayfinder/WayfinderSubLocation";
import VideoGenerationStatusPage from "./Component/backend/VideoGenerationStatusPage";
import StandaloneAvatarScreen from "./Component/Wayfinder/StandaloneAvatarScreen";
import DummyCategory from "./Component/Wayfinder/DummyCategory";
import WeatherWidget from "./Component/WeatherWidget";

import MappedInDataTest from './Component/Wayfinder/MappedInDataTest';
import AllLocationsPage from './Component/Wayfinder/AllLocationsPage';

// New Wayfinder Page Components
import CategoryManagerPage from './Component/Wayfinder/CategoryManagerPage';
import LocationsManagerPage from './Component/Wayfinder/LocationsManagerPage';
import AllLocationsManagerPage from './Component/Wayfinder/AllLocationsManagerPage';
import BrandingPage from './Component/Wayfinder/BrandingPage';
import MobilePage from './Component/Wayfinder/MobilePage';
import GlobalPage from './Component/Wayfinder/GlobalPage';
import AvatarPage from './Component/Wayfinder/AvatarPage';
import MapPage from './Component/Wayfinder/MapPage';
import CaptionsPage from './Component/Wayfinder/CaptionsPage';
import VideosPage from './Component/Wayfinder/VideosPage';
import TagsPage from './Component/Wayfinder/TagsPage';
import WayfinderRedirect from './Component/Wayfinder/WayfinderRedirect';

// In your routes:


// import N8nChatWidget from './Component/N8nChatWidget';

function App() {
  const { authState } = useContext(AuthContext);
  const { showHeader, showSidebar } = useSelector((state) => state.visibility);

  return (
    <>
      {showHeader && <Header />}
      {authState.token && showSidebar ? (
        <>
          <RightSidebar />
          <Leftbar />
        </>
      ) : null}
      <Routes>
        <Route path="/not-authorized" element={<Unauthorized />} />
        <Route path="/not-found" element={<NotFound />} />

        <Route path="/login" element={<Login />} />
        <Route path="/record" element={<AudioToText />} />
        <Route
          path="/"
          element={
            <ProtectedRoute
              element={ViewClient}
              fallbackElement={BackendForm}
              roles={[1, 2]}
              projecttype="aihsystem"
            />
          }
        />
        <Route
          path="/backend"
          element={
            <ProtectedRoute
              element={BackendForm}
              roles={[1, 2]}
              projecttype="aihsystem"
            />
          }
        />
        {/* <Route
          path="/view-client-logs/"
          element={<ProtectedRoute element={ViewClientLogs} roles={[1]}/>}
        /> */}
        <Route
          path="/view-client-logs/"
          element={<ProtectedRoute element={FilterReport} roles={[1]} />}
        />
        <Route
          path="/billing-track/:userId"
          element={<ProtectedRoute element={BillingTrackTables} roles={[1]} />}
        />
        <Route
          path="/view-clients"
          element={<ProtectedRoute element={ViewClient} roles={[1]} />}
        />

        <Route
          path="/view-py-logs"
          element={<ProtectedRoute element={ViewPyLogs} roles={[1]} />}
        />

        <Route path="/qr/:id/:btnId" element={<QrLink />} />

        <Route
          path="/view-global-settings/:id/:userId"
          element={
            <ProtectedRoute
              element={ButtonSettingsForm}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/questions-bank/:userId/:topicId"
          element={
            <ProtectedRoute
              element={QuestionBank}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/view-clients/:id"
          element={<ProtectedRoute element={ViewClient} roles={[1]} />}
        />

        <Route
          path="/view-py-logdetails/:id"
          element={
            <ProtectedRoute
              element={ViewPyLogDetails}
              roles={[1]}
              projecttype="aihsystem"
            />
          }
        />

        <Route
          path="/view-profile/:id"
          element={<ProtectedRoute element={ViewProfile} roles={[1, 2]} />}
        />
        <Route
          path="/view-avatar-settings/:id"
          element={
            <ProtectedRoute
              element={BackendForm}
              roles={[1, 2]}
              projecttype="aihsystem"
            />
          }
        />

        <Route
          path="/view-button-settings/:id"
          element={
            <ProtectedRoute
              element={ButtonContainer}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/view-splash-settings/:userId"
          element={
            <ProtectedRoute
              element={SplashContent}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/global-settings/:userId"
          element={
            <ProtectedRoute
              element={GlobalSettingForm}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />
        <Route
          path="/availablity-settings/:userId"
          element={
            <ProtectedRoute element={AvailablitySettings} roles={[1, 2]} />
          }
        />
        <Route
          path="/view-button-logs/:userId"
          element={
            <ProtectedRoute
              element={ButtonLogs}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/trivia-quiz/:userId"
          element={
            <ProtectedRoute
              element={TriviaQuizMenu}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/add-client/:id?"
          element={<ProtectedRoute element={AddClient} roles={[1]} />}
        />

        <Route
          path="/quiz-report/:userId"
          element={
            <ProtectedRoute
              element={QuizReporting}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route path="/:client_url" element={<ClientValidation />} />
        <Route path="/:login/:slug" element={<ClientLogin />} />

        <Route
          path="/admin/global-settings"
          element={<ProtectedRoute element={GlobalSettings} roles={[1]} />}
        />

        <Route
          path="/admin/wayfinder-management"
          element={<ProtectedRoute element={WayfinderManagement} roles={[1]} />}
        />

        <Route
          path="/admin/mappedin-explorer"
          element={<ProtectedRoute element={MappedInDataExplorer} roles={[1]} />}
        />

        <Route
          path="/admin/assets-report"
          element={<ProtectedRoute element={AssetsReport} roles={[1]} />}
        />

        <Route
          path="/admin/assets-test"
          element={<ProtectedRoute element={UploadTest} roles={[1]} />}
        />

        {/* Video Management Admin Dashboard */}
        <Route
          path="/admin/video-management"
          element={
            <ProtectedRoute element={VideoManagementAdmin} roles={[1]} />
          }
        />

        {/* Video Generation Status Monitor */}
        <Route
          path="/admin/video-generation-status"
          element={
            <ProtectedRoute element={VideoGenerationStatusPage} roles={[1]} />
          }
        />

        {/* 2Fa enable */}
        <Route
          path="/enable-2fa"
          element={<ProtectedRoute element={EnableTwoFa} roles={[1, 2]} />}
        />

        <Route path="/2fa-verification" element={<TwoFaVerification />} />

        {/* Forgot Password */}

        <Route path="/forgot-password" element={<ForgotPasswordInput />} />

        <Route path="/reset-password/:token" element={<ResetPasswordPage />} />

        {/* WayFinder */}
        <Route path="/avatar-test" element={<AvatarScreenTest />} />
        
        {/* Redirect old wayfinder route to new categories page */}
        <Route
          path="/wayfinder/:userId"
          element={
            <ProtectedRoute
              element={WayfinderRedirect}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder-location/:userId"
          element={
            <ProtectedRoute
              element={MainLocationTab}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />
        <Route
          path="/wayfinder-locations/:userId/:locationId"
          element={
            <ProtectedRoute
              element={WayfinderLocation}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder-navigation/:userId"
          element={
            <ProtectedRoute
              element={MainNavigationTab}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder-main-category/:userId"
          element={
            <ProtectedRoute
              element={WayfinderMainCategory}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />
        <Route
          path="/wayfinder-main-sub-category/:userId"
          element={
            <ProtectedRoute
              element={WayfinderMainSubCategory}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />
        <Route
          path="/wayfinder-sub-category/:userId/:subCategoryId"
          element={
            <ProtectedRoute
              element={WayfinderSubCategory}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />
        <Route
          path="/wayfinder-category/:userId/:categoryId"
          element={
            <ProtectedRoute
              element={WayfinderCategory}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        {/* Ordering Routes */}
        <Route
          path="/category-order/:userId"
          element={
            <ProtectedRoute
              element={CombinedCategorySubcategoryOrderPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />
        <Route
          path="/subcategory-order/:userId/:categoryId"
          element={
            <ProtectedRoute
              element={SubCategoryOrderSelector}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />
        <Route
          path="/location-order/:userId"
          element={
            <ProtectedRoute
              element={LocationSelector}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />
        <Route
          path="/parent-location-order/:userId/:parentId/:parentType"
          element={
            <ProtectedRoute
              element={LocationSelector}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder-locations/:userId/:locationId"
          element={
            <ProtectedRoute
              element={WayfinderLocation}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder-sub-locations/:userId/:subLocationId"
          element={
            <ProtectedRoute
              element={WayfinderSubLocation}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/qr-scan-logs/:userId"
          element={
            <ProtectedRoute
              element={QRCodeScanLogs}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        {/* Mobile QR Scan Page - Public Route */}
        <Route
          path="/wayfinder/:locationName/:locationId/:language"
          element={<MobileQRScanPage />}
        />
        {/* Fallback route for old QR codes without language */}
        <Route
          path="/wayfinder/:locationName/:locationId"
          element={<MobileQRScanPage />}
        />

        {/* Direct Map Link Redirect Page - logs scan then redirects to MappedIn */}
        <Route
          path="/direct-map-redirect/:locationId"
          element={<DirectMapRedirectPage />}
        />

        {/* Standalone Avatar Screen - Public Route for direct location access */}
        <Route
          path="/location/:userId/:locationId"
          element={<StandaloneAvatarScreen />}
        />

        {/* HeyGen Test Component - Protected Route */}
        <Route
          path="/heygen-test"
          element={<ProtectedRoute element={HeyGenTestComponent} roles={[1]} />}
        />

        {/* MappedIn Category Viewer - Protected Route */}
        <Route
          path="/mappedin-categories"
          element={<ProtectedRoute element={DummyCategory} roles={[1]} />}
        />

        {/* Weather Widget Preview */}
        <Route path="/weather-widget" element={<WeatherWidget />} />

        {/* All Locations Page - Standalone */}
        <Route
          path="/all-locations/:userId"
          element={
            <ProtectedRoute
              element={AllLocationsPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        {/* New Wayfinder Tab Pages with Layout */}
        <Route
          path="/wayfinder/categories/:userId"
          element={
            <ProtectedRoute
              element={CategoryManagerPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/locations/:userId"
          element={
            <ProtectedRoute
              element={LocationsManagerPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/all-locations/:userId"
          element={
            <ProtectedRoute
              element={AllLocationsManagerPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/branding/:userId"
          element={
            <ProtectedRoute
              element={BrandingPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/mobile/:userId"
          element={
            <ProtectedRoute
              element={MobilePage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/global/:userId"
          element={
            <ProtectedRoute
              element={GlobalPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/avatar/:userId"
          element={
            <ProtectedRoute
              element={AvatarPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/map/:userId"
          element={
            <ProtectedRoute
              element={MapPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/captions/:userId"
          element={
            <ProtectedRoute
              element={CaptionsPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/videos/:userId"
          element={
            <ProtectedRoute
              element={VideosPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />

        <Route
          path="/wayfinder/tags/:userId"
          element={
            <ProtectedRoute
              element={TagsPage}
              roles={[1, 2]}
              projecttype="menusystem"
            />
          }
        />


      </Routes>
      {/* Add the ToastContainer component at the root level */}
      <ToastContainer />
    </>
  );
}

function AppWrapper() {
  return (
    <Router>
      <App />
      {/* <N8nChatWidget 
        webhookUrl="https://amitmahto64.app.n8n.cloud/webhook/0348695f-8783-48e3-994c-6225e53e35c9/chat"
        title="Support Chat"
        position="right"
      /> */}
    </Router>
  );
}

export default AppWrapper;
